import set from "lodash/set";
import reduce from "lodash/reduce";

export default function deepen(obj) {
  return reduce(obj, (result, value, path) => set(result, path, value), {});
}
